<template>
        <v-container class=" mx-auto rp rp_m rp_lg rp_sc rp_t justify-content-around">
            <div v-for="index in 7" class="col-md-10">
                <div style="border-radius: 25%"
                     class="my-1 d-inline-flex shadow-lg mx-auto my-3 flex-column flex-md-row">
                    <v-img class="mt-5" :src="icon" max-width="150" max-height="150" contain
                           style="border-radius: 20px; position: absolute; margin-right: -75px"></v-img>

                    <!--    background-color: rgb(239,239,239);-->
                    <div class="pt-5"
                         style=" border-radius: 20px; padding-right: 90px; background-color: rgb(255,255,255); padding-left: 10px">
                        <div class="d-flex flex-column">
                            <p style="color: blue; font-weight: bold; font-size: 1.2rem">{{ name }}</p>
                            <p class="text-wrap">{{ description.substr(0, 50) }} ...</p>
                            <p class="text-left mx-3" style="text-align: left!important;">
                                <a style="color: blue;" @click="$emit('moreClick')">
                                    اطلاعات بیشتر...
                                </a>
                            </p>
                            <p class="mb-0">
                <span class="d-inline-block px-2  text-white rounded underline"
                      style="padding-top:2px ; padding-bottom: 2px ;background-image: linear-gradient(90deg, rgba(78,10,23,1) 0%, rgb(203,57,84) 50%, rgba(78,10,23,1) 100%)">{{
                        rental_period
                    }}</span>
                            </p>

                            <p class="mt-1">
                <span class="d-inline-block px-2 py-2 rounded"
                      style="
                      color: goldenrod;
                      font-weight: bold;
                      background-image: linear-gradient(90deg, rgba(78,10,23,1) 0%, rgb(203,57,84) 50%, rgba(78,10,23,1) 100%)">{{
                        pricings
                    }}</span>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </v-container>
</template>

<script>
export default {
    name: "erfCard",
    computed: {
        pricings() {
            if (!this.config || typeof this.config != 'object') return "توافقی";
            let ret = "";

            for (let item of this.config) {
                ret += ` ${item.key}  ${item.value} `;
            }

            return ret;
        }
    },
    data() {
        return {
            icon: "https://via.placeholder.com/150",
            name: "شسکیمبنت شسیکمبنت شسک یمنبنتش",
            description: "شحسخینبح خشسیبحش هسیبحخه شسیحبه شسیحبهشسحیهبش حجسخیهب ح ش خسهیب حشه س ی ب ح جخهشسیبحخهش س یحبهشسحیبهش حجسهیب ح شهسیبحه شسیبح هشسی حجب هشح س ی ه بحشسیهبحجشس یهبحجشسهیبحج هشسیبحهشسیحج بهشحجسیهبحجشسیهبحجشس یهبشح ج سیهبحجشسهی بجحشسه یبجحشسهیبح جشهسیبحجه شسیحبهشسجیحبهشحجسی بهشجحبخه",
            rental_period: "یک ماهه",
            config: [{
                mainType: "price",
                //mainType : "time",

                //if main type be time
                type: "secound",
                // type: "minute",
                // type: "hour",

                //if main type be price
                // type: "fromPrice",
                // type: "toPrice",
                // type: "price",

                key: "عنوان نمایشی",
                value: "مقدار",
            }],
        }
    }
}
</script>

<style >
.rp {
    display: grid;
    position: sticky;
    left: 0;
    right: 0;
    min-width: 95vw !important;
    max-height: fit-content !important;
}

@media (min-width: 576px) {
    .rp_m {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (min-width: 768px) {
    .rp_t {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 992px) {
    .rp_sc {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) {
    .rp_lg {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}
</style>